<bcu-local-spinner [size]="40" [visible]="(player$ | async).loading" *ngIf="(player$ | async).loading">
</bcu-local-spinner>
<div class="player-search black-gray">
  <div class="px-5 pt-4" translate>ChangePlayer.ChangePlayerText</div>
  <div class="mx-5 py-3 player-search-border-bottom">
    <form [formGroup]="form" novalidate *ngIf="form">
      <input class="player-search-input" type="text" formControlName="search"
        placeholder="{{'ChangePlayer.SearchPlayerPlaceholder' | translate}}">
      <span class="ic-player-search player-search-icon"></span>
    </form>
  </div>
  <div class="mx-5 mt-3 mb-2" *ngIf="(players$ | async).loaded && (players$ | async).hasItems">
    {{ 'ChangePlayer.ResultsText' | translate }} ({{(players$ | async).items.length}})
  </div>
  <app-player-list></app-player-list>
  <div class="mx-5 mt-3" *ngIf="(players$ | async).loaded && !(players$ | async).hasItems" translate>
    ChangePlayer.NoPlayerFound
  </div>
</div>
